<template>
  <div>
    <div class="side-head">
      <h2>{{ shortenName(product.product.product_name, airport.airport_name) }}</h2>
      <h6>{{ airport.airport_name }} {{ $t('banner.airport') }}</h6>
      <span class="size"><i class="icon-bus"></i>{{ $t('airportlounge.results.terminal') }} {{ product.product.terminal }}</span>
        <span class="info-link text-uppercase">
        <span @click="moreInfo = product.product">
          <i class="icon-add"></i>
          {{ $t('payment.basket.more_info') }}
        </span>
      </span>
    </div>
    <div class="wrap">
      <div class="side-img" v-if="!upgrade">
        <img 
          :src="`https://skyparkupload1.s3-eu-west-1.amazonaws.com/products/airportlounge/${product.product.product_id}/${product.product.product_id}_1.jpg`" 
          alt="image-description">
      </div>
      <div class="holder">
        <div class="info-detail">
          <span class="text">
            <span class="title">{{ $t('airportlounge.payment.from') }}</span> 
            {{ dateAtTime(quote.dateA, quote.timeA) }}
          </span>
          <div class="price-info" v-if="upgrade">
            <div class="price-wrap">
              <strong class="price">{{ currency }}{{ product.product.full_price }}</strong>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { get, sync } from 'vuex-pathify';
import mixins from "@/mixins";

export default {
  name: "basket-parking-item",
  mixins: [mixins.format, mixins.globals],
  computed: {
    airport: get("results/airport"),
    moreInfo: sync("modals/moreInfo")
  },
  props: {
    product: { required: true, default: () => {} },
    quote: { required: true, default: () => {} },
    upgrade: { required: true, default: false }
  }
};
</script>